// form
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';
import { DesktopDateTimePicker } from "@mui/x-date-pickers";

// ----------------------------------------------------------------------

type IProps = {
    name: string;
    label: string;
};

type Props = IProps&TextFieldProps;

export default function RHFDateTimePicker({ name, label, ...other }: Props) {
    const { control } = useFormContext();

    return (
        <Controller
            name={ name }
            control={ control }
            render={ ({ field, fieldState: { error } }) =>
                (
                    <DesktopDateTimePicker
                        { ...field }
                        showToolbar={ true }
                        label={ label }
                        mask={ '__.__.____, __:__' }
                        disabled={ other.disabled || false }
                        inputFormat="dd.MM.yyyy, HH:mm"
                        renderInput={ (params) =>
                            <TextField
                                { ...params }
                                error={ !!error }
                                helperText={ error?.message }
                                { ...other }
                                fullWidth
                            /> }
                    />
                ) }
        />
    );
}
